import {
  SET_PROFILE_IMAGE
} from '../utils/constants'

const initialState = {
  profileImage: null,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PROFILE_IMAGE:
      return { ...state, profileImage: payload }
    default:
      return state
  }
}
